import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

// Load VeeValidate, font icons, portal vue and wrapper input fields (config shared with ipro-ui-kit-vuejs)
import 'ipro-ui-kit-vuejs/src/main.config';

// The following file needs to be loaded explicitly instead of including it inside main.config
import 'ipro-ui-kit-vuejs/src/main.scss';

if (process.env.NODE_ENV === 'production' && (GLOBALS.ENDPOINTS || '').match(/production/)) {
  if (['auth', 'portal'].includes(GLOBALS.APP || '')) {
    import('../externals/analytics');
  }
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
